import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/o/$orgId/usage/overview')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/o/$orgId/usage/sessions',
      params,
    })
  },
})
